import { createUseStyles } from 'react-jss'

import { COLOR, MQ } from 'utils/constants'

export const useStyles = createUseStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '88%',
    margin: 'auto',
    [MQ.TABLET]: {
      width: '90%',
    },
  },
  title: {
    color: COLOR.ORANGE,
    margin: [20, 0],
    [MQ.TABLET_LARGE]: {
      margin: [40, 0],
    },
  },
  subtotalGrid: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexDirection: 'column',
    margin: [20, 0, 10],
    padding: [0, 0, 15],
    borderBottom: `2px solid ${COLOR.LIGHT_GREEN}`,
  },
  subtotal: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    margin: [0, 0, 5],
    maxWidth: 367,
  },
  total: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    margin: [0, 0, 40],
    maxWidth: 367,
  },
  checkout: {
    backgroundColor: COLOR.DARK_GREEN,
    outline: 'none',
    border: 'none',
    padding: [10, 0],
    margin: [0, 0, 70],
    color: COLOR.WHITE,
    cursor: 'pointer',
    width: 125,
    borderRadius: 8,
    [MQ.TABLET]: {
      width: 141,
    },
  },
  emptyCart: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: [50, 0],
  },
  empty: {
    color: COLOR.DARK_GREEN,
  },
  continueShopping: {
    backgroundColor: COLOR.DARK_GREEN,
    padding: [15, 0],
    margin: [20, 0, 70],
    color: COLOR.WHITE,
    textDecoration: 'none',
    textAlign: 'center',
    borderRadius: 8,
    width: 225,
  },
  line: {
    height: 2,
    width: '100%',
    backgroundColor: COLOR.LIGHT_GREEN,
  },
  bold: {
    fontWeight: 700,
  },
})
